module.exports = __webpack_public_path__ + "img/沙尘暴.1a54c5e4.png";